import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_input = _resolveComponent("ui-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nav-search-layer", { top: $setup.showCustom }]),
    ref: "dom"
  }, [
    _createVNode($setup["Search"], {
      keyword: $setup.customValue,
      onClick: $setup.enterPosition,
      hideContent: $setup.hideSearchContent
    }, {
      replace: _withCtx(() => [
        _createVNode(_component_ui_input, {
          type: "text",
          modelValue: $setup.showCustom ? $setup.customValue : $props.value ? $props.valueLabel : '',
          placeholder: $props.placeholder,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = val => ($setup.customValue = val)),
          onFocus: $setup.focuHandler,
          onBlur: $setup.blurHandler,
          width: "100%",
          class: "nav-input",
          ref: "text"
        }, {
          preIcon: _withCtx(() => [
            _createVNode(_component_ui_icon, {
              type: $props.icon,
              class: "nav-pre-icon"
            }, null, 8 /* PROPS */, ["type"])
          ]),
          icon: _withCtx(() => [
            _createVNode(_component_ui_icon, {
              type: "state_f",
              class: "nav-last-icon",
              onClick: $setup.clearHandler,
              ctrl: ""
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "placeholder"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["keyword", "hideContent"])
  ], 2 /* CLASS */))
}